// Countries are stored as ISO 3166-1 alpha-2 codes, as the backend and the accounting exports expect

export const HOME_COUNTRY = 'SK'

const countryCodes = [
    'SK', 'CZ', 'AT', 'HU', 'PL', 'DE', 'UA', 'BE', 'BG', 'HR', 'CY', 'DK', 'EE', 'FI', 'FR', 'GR',
    'IE', 'IT', 'LT', 'LV', 'LU', 'MT', 'NL', 'PT', 'RO', 'SI', 'ES', 'SE', 'CH', 'NO', 'GB', 'US',
]

export interface CountryOption {
    value: string
    label: string
}

// Named in the user's language where the browser can, by code where it cannot
export function countryOptions(language: string): CountryOption[] {
    let displayNames: { of: (code: string) => string | undefined } | undefined

    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        displayNames = new (Intl as any).DisplayNames([language], {type: 'region'})
    } catch {
        displayNames = undefined
    }

    const options = countryCodes.map(code => ({value: code, label: displayNames?.of(code) ?? code}))

    // Home first, the rest alphabetically
    return [
        ...options.filter(option => option.value === HOME_COUNTRY),
        ...options.filter(option => option.value !== HOME_COUNTRY).sort((a, b) => a.label.localeCompare(b.label, language)),
    ]
}
